// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1ZbGm","info":"UpdateTermsInfo_info__13V2Q"};